export { default } from './SizeShrink'
